import {
  Sender,
  MessageType,
} from '@wix/ambassador-innovation-widget-v1-message/types';

import { addMessage } from '../messages';
import { createAppAsyncThunk } from '../createAppAsyncThunk';

import {
  extractAnswerText,
  FAQ_CHAT_LABEL,
  FAQ_QUESTIONS_SERVERLESS_URL,
  FaqQuestionEntry,
  faqQuestionServerlessUrl,
  toWidgetFaqQuestions,
} from './model';

export const getFaqQuestions = createAppAsyncThunk(
  'faqQuestions/get',
  async (_, { extra: { httpClient } }) => {
    const { data } = await httpClient.get<Record<string, any>[]>(
      FAQ_QUESTIONS_SERVERLESS_URL,
      { params: { label: FAQ_CHAT_LABEL } },
    );
    return toWidgetFaqQuestions(data);
  },
);

export const selectFaqQuestion = createAppAsyncThunk(
  'faqQuestions/select',
  async (
    { id, question }: { id: string; question: string },
    { dispatch, extra: { httpClient } },
  ) => {
    await dispatch(addMessage({ body: { mainText: question } }));

    const { data } = await httpClient.get<FaqQuestionEntry>(
      faqQuestionServerlessUrl(id),
    );

    await dispatch(
      addMessage({
        body: { mainText: extractAnswerText(data.draftjs) ?? '' },
        sender: Sender.USER,
        messageType: MessageType.FAQ_ANSWER,
      }),
    );
  },
);
